module.exports = __webpack_public_path__ + "files/087c0692ddd90f62d0fd861e5087ce52.png";